import { Component, OnInit } from "@angular/core";
import { LoginService } from "src/app/services/login.service";
import { is } from "date-fns/locale";
import { ChangePasswordComponent } from "../settings-components/change-password/change-password.component";
import { MatDialog, MatSnackBar } from "@angular/material";
import { UserServiceService } from "src/app/services/user-service.service";
import { AddBankDetailsComponent } from "../settings-components/add-bank-details/add-bank-details.component";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { EmergencyContactsComponent } from "../account-components/emergency-contacts/emergency-contacts.component";
import { UpdatePhoneComponent } from "../settings-components/update-phone/update-phone.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { PushMessagingService } from "src/app/services/push-messaging.service";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';
@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"],
})
export class UserProfileComponent implements OnInit {
  selectedLanguage: string;
  user: any;
  userName: string = "";
  showSettingsSubMenu: boolean = false;
  showHelpCenter: boolean = false;
  previewUrl: any;
  isSideNavOpen: boolean = false;
  isLoggedIn: boolean = false;
  constructor(
    private loginService: LoginService,
    private dialog: MatDialog,
    private userService: UserServiceService,
    private snackBar: MatSnackBar,
    private router: Router,
    private pushService: PushMessagingService,
    private translateService: TranslateService,
    private languageService: LanguageService
  ) {
    this.loginService.checkIsImgUpdated.subscribe((isUpdated) => {
      if (isUpdated == true) {
        this.loginService.profilePic.subscribe((img) => {
          this.previewUrl = "";
          setTimeout(() => {
            this.previewUrl = img;
          }, 100);
        });
      }
    });
    this.userService.openVerifyPhone.subscribe((val) => {
      if (val) {
        this.mobileVerification();
      }
    });
    this.languageService.selectedLanguage$.subscribe(language => {
      this.selectedLanguage = language;
    });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.user != null ? this.fetchData() : this.router.navigateByUrl("/home");
    this.switchLanguage(this.selectedLanguage);
  }

  switchLanguage(languageCode: string): void {
    this.translateService.use(languageCode);
  }
  fetchData() {
    let id = { userID: this.user.userID };
    let token = localStorage.getItem("token");
    this.loginService.fetchUserDetails(id, token).subscribe(
      (posRes) => {
        if (posRes.response == 3) {
          this.setValues(posRes.customerInfo[0]);
          localStorage.setItem("user", JSON.stringify(posRes.customerInfo[0]));
          this.user = posRes.customerInfo[0];
          this.userService.user = posRes.customerInfo[0];
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client Side Error", err.message);
        } else {
          console.log("Server Side Error", err.message);
        }
      }
    );
  }
  addEmergencyContacts() {
    let dailogRef = this.dialog.open(EmergencyContactsComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: { userID: this.user.userID },
    });
  }
  openSideNav() {
    this.isSideNavOpen = !this.isSideNavOpen;
    this.fetchData();
  }
  deleteAccount() {
    let obj = {
      userID: this.user.userID,
    };
    let token = localStorage.getItem("token");
    this.loginService.isThisAccountElegibleToDelete(obj, token).subscribe(
      (res) => {
        if (res.response == 3) {
          this.showDeleteAlert();
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      },
      (err: HttpErrorResponse) => {
        const txtmsg = err.message.trim();
        const txtmsg52 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg52, '');
      }
    );
  }
  logOut() {
    this.loginService.showLoader.next(true);
    let obj = {
      userID: this.user.userID,
      deviceToken: "",
      deviceType: "web",
    };
    let deviceToken = this.pushService.fcmToken;
    if (deviceToken != null) {
      obj.deviceToken = deviceToken;
    } else {
      obj.deviceToken = "";
    }
    let token = localStorage.getItem("token");
    this.loginService.logOut(obj, token).subscribe(
      (posRes) => {
        this.loginService.showLoader.next(false);
        if (posRes.response == 3) {
          this.loginService.checkIsLoggedIn.next(false);
          this.previewUrl = "https://india-live-api.talentasker.com/user.png";
          this.confirmDelete();
        } else {
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err: HttpErrorResponse) => {
        this.loginService.showLoader.next(false);
        const txtmsg = err.message.trim();
        const txtmsg32 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg32, '');
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error);
        } else {
          console.warn("Server Error", err.error);
        }
      }
    );
  }
  showDeleteAlert() {
    let dailogRef = this.dialog.open(DeleteDialogComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: "Do you want to delete your account..?",
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.logOut();
      }
    });
  }
  confirmDelete() {
    let obj = { userID: this.user.userID };
    let token = localStorage.getItem("token");
    this.loginService.deleteMyAccount(obj, token).subscribe(
      (res) => {
        if (res.response === 3) {
          localStorage.clear();
          this.loginService.isLoggedIn.next(false);
          this.router.navigateByUrl("/home");
        }
      },
      (err: HttpErrorResponse) => {
        const txtmsg = err.message.trim();
        const txtmsg27 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg27, '');
        localStorage.clear();
        this.router.navigateByUrl("/home");
      }
    );
  }
  setValues(info) {
    this.userName = info.firstName + " " + info.lastName;
    if (info.profilePic == "") {
      this.previewUrl = "https://india-live-api.talentasker.com/user.png";
    } else {
      this.previewUrl = "https://india-live-api.talentasker.com" + info.profilePic;
    }
  }
  //message alerts showing
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "red-snackbar",
    });
  }
  changePassword() {
    let dailogRef = this.dialog.open(ChangePasswordComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: { userID: this.user.userID },
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res != undefined) {
        if (res.response == 3) {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      }
    });
  }
  mobileVerification() {
    let dailogRef = this.dialog.open(UpdatePhoneComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: { userID: this.user.userID, number: this.user.phoneNumber },
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res != undefined) {
        const txtmsg = this.translateService.instant("Phone Verification Success");
        this.openSnackBar(txtmsg, '');
        this.userService.isFetchUser.next(true);
        return;
        if (res.response == 3) {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
          this.fetchData();
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      } else {
        const txtmsg1 = this.translateService.instant("Phone Verification Failed");
        this.openSnackBar(txtmsg1, '');
      }
    });
  }
  addBankDetails() {
    let dailogRef = this.dialog.open(AddBankDetailsComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: { userID: this.user.userID },
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res != undefined) {
        if (res.response == 3) {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
          this.fetchData();
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      }
    });
  }
}
